import * as React from "react";
import {Component} from "react";
import {Col, Row} from "react-bootstrap";
import Tippy from "@tippy.js/react";

interface GlyphProps {
    glyphicon?: string;
    style?: React.CSSProperties;
    label?: string;
    onRight?: boolean;
}

const Glyph = ({glyphicon, label, style, onRight}: GlyphProps) => {
    const positionModifier = onRight && "icon-right";
    const glyphClass = glyphicon && `glyphicon glyphicon-${glyphicon} ${positionModifier}`;
    return (<span style={style} className={glyphClass}>{label}</span>);
};

interface GlyphButtonProps extends GlyphProps {
    changeStyleProperty: string;
    styleProperty?: string;
    value?: string;
    title: string;
    glyphicon?: string;
    style?: React.CSSProperties;
    label?: string;
    selected?: boolean;
    onClick?: React.MouseEventHandler;
}

const GlyphButton = (
    {
        changeStyleProperty,
        styleProperty,
        value,
        title,
        glyphicon,
        style,
        label,
        selected = false,
        onClick,
    }: GlyphButtonProps) => {
    const selectedClass = selected ? "selected" : "";
    // The "change-" property is significant to the CSS.
    const buttonClass = `change-${changeStyleProperty} ${styleProperty} button-switch ${selectedClass}`;
    // onMouseDown works because we can cancel the event and preserve focus.
    return (
        <button className={buttonClass} data-value={value} title={title} onMouseDown={onClick}>
            <Glyph label={label} glyphicon={glyphicon} style={style} />
        </button>
    );
};

interface PropertyContainerComponentProps {
    name: string;
    label?: string;
    tip?: string;
    isColStretched?: boolean;
}

// noinspection JSUnusedLocalSymbols
class PropertyRowComponent extends Component<PropertyContainerComponentProps> {
    render() {
        const {name, label, tip, children, isColStretched} = this.props;
        const infoColLength = isColStretched ? 12 : 4;
        const childrenColLength = isColStretched ? 12 : 8;
        
        return (
            <Row className={`${name}-section properties`} componentClass={"section"}>
                {/* Previously there was a hack of changing column size and giving a negative margin. */}
                <Col md={infoColLength} style={{whiteSpace:"nowrap"}}>
                    {label}
                    {
                        tip &&
                        <Tippy
                            content={tip}
                            arrow={true}
                            arrowType={"sharp"}
                            placement={"left"}
                            maxWidth={230}
                            size={"large"}
                            theme={"dark"}
                            offset={25}
                        >
                            <span className="info-tooltip"/>
                        </Tippy>
                    }
                </Col>
                <Col md={childrenColLength}>
                    {children}
                </Col>
            </Row>
        );
    }
}

export {
    PropertyRowComponent,
    GlyphButton,
    Glyph,
};



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/toolbox/PropertiesView.tsx